import React from "react";
import { es } from "@/locales/es";
import { appUrl } from "@/lib/referral";

/**
 * Spanish mirror of StalenessBanner.jsx — same structure/behavior (shown
 * only when the entitlements fetch failed and the page is rendering the
 * last-known snapshot), copy translated into Spanish ("tú" register).
 * Date formatting uses the plain "es" Intl locale (no region) to stay
 * neutral rather than picking Spain- or Latin-America-specific
 * conventions.
 */
export const StalenessBannerES = ({ lastUpdated }) => {
  const when = lastUpdated
    ? new Date(lastUpdated).toLocaleString("es", {
        year: "numeric",
        month: "short",
        day: "numeric",
      })
    : null;
  const t = es.staleness;

  return (
    <div
      role="status"
      aria-live="polite"
      className="mb-10 border border-gold/40 bg-gold/[0.06] px-5 py-4 flex items-start gap-3"
      data-testid="entitlements-staleness-banner-es"
    >
      <span
        className="mt-[6px] block w-1.5 h-1.5 rounded-full bg-gold flex-shrink-0"
        aria-hidden="true"
      />
      <p
        className="font-body italic text-sm text-nearblack/80 leading-relaxed"
        data-testid="entitlements-staleness-copy-es"
      >
        {t.prefix}
        {when ? ` (${when})` : ""} — {t.notice}{" "}
        <a
          href={appUrl("https://work.voxiumscript.com", { lang: "es" })}
          className="underline decoration-gold/60 underline-offset-2 hover:text-gold-600"
        >
          work.voxiumscript.com
        </a>{" "}
        {t.suffix}
      </p>
    </div>
  );
};

export default StalenessBannerES;
